import React from 'react';
import { useNavigate } from 'react-router-dom';
import RoleDashboardShell from '@/presentation/dashboard/RoleDashboardShell';
import { useRoleDashboardConfig } from '@/presentation/dashboard/useRoleDashboardConfig';
import { useDashboardHomeCopy } from '@/presentation/dashboard/dashboardHomeLocale';
import PublicIeltsQuizSpotlight from '@/presentation/quiz/PublicIeltsQuizSpotlight';

export default function TeacherDashboard({ session, onLogout }) {
  const config = useRoleDashboardConfig(session);
  const t = useDashboardHomeCopy(session);
  const navigate = useNavigate();

  return (
    <RoleDashboardShell
      session={session}
      appTitle={config.appTitle}
      systemTagline={config.systemTagline}
      roleLabel={config.roleLabel}
      menuItems={config.menuItems}
      onLogout={onLogout}
    >
      <div className="mx-auto max-w-7xl space-y-6">
        <PublicIeltsQuizSpotlight />

        <section className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <h1 className="font-headline text-4xl font-extrabold">{t.heroTitle}</h1>
            <p className="mt-2 text-slate-600">{t.heroSubtitle}</p>
          </div>
          <button
            type="button"
            onClick={() => navigate('/quizzes/create')}
            className="rounded-xl bg-blue-600 px-6 py-3 font-bold text-white"
          >
            {t.createQuiz}
          </button>
        </section>

        <div className="grid gap-6 md:grid-cols-3">
          <article className="rounded-3xl bg-blue-600 p-7 text-white shadow-sm">
            <p className="text-sm text-blue-100">{t.activeQuizzes}</p>
            <p className="mt-2 text-5xl font-black">12</p>
          </article>
          <article className="rounded-3xl bg-white p-7 shadow-sm">
            <p className="text-sm text-slate-500">{t.totalParticipants}</p>
            <p className="mt-2 text-5xl font-black">2,481</p>
          </article>
          <article className="rounded-3xl bg-emerald-100 p-7 shadow-sm">
            <p className="text-sm text-emerald-700">{t.avgPerf}</p>
            <p className="mt-2 text-5xl font-black text-emerald-700">84%</p>
          </article>
        </div>

        <article className="rounded-3xl bg-white p-6 shadow-sm">
          <h2 className="font-headline text-xl font-bold">{t.recentTitle}</h2>
          <div className="mt-4 space-y-3">
            {t.demoRows.map((row) => (
              <div key={row[0]} className="grid grid-cols-4 gap-4 rounded-xl border border-slate-100 p-4 text-sm">
                <div className="font-semibold">{row[0]}</div>
                <div>{row[1]}</div>
                <div className="font-bold text-blue-600">{row[2]}</div>
                <div>{row[3]}</div>
              </div>
            ))}
          </div>
        </article>
      </div>
    </RoleDashboardShell>
  );
}

